(function () {
  'use strict';

  var ROOT = '[data-ch-native-sort-owner="collection-meta"]';
  var SHEET = '[data-ch-native-sort-sheet]';
  var TRIGGER = '[data-ch-native-sort-trigger]';
  var CLOSE = '[data-ch-native-sort-close]';
  var OPTION = '[data-ch-native-sort-value]';
  var inertRecords = [];
  var activeRoot = null;

  function closest(node, selector) {
    return node && node.closest ? node.closest(selector) : null;
  }

  function rootFor(node) {
    return closest(node, ROOT);
  }

  function sheetFor(root) {
    return root && root.querySelector ? root.querySelector(SHEET) : null;
  }

  function triggerFor(root) {
    return root && root.querySelector ? root.querySelector(TRIGGER) : null;
  }

  function optionsFor(sheet) {
    if (!sheet || !sheet.querySelectorAll) return [];
    return Array.prototype.slice.call(sheet.querySelectorAll(OPTION));
  }

  function setRovingOption(sheet, target) {
    var options = optionsFor(sheet);
    if (!options.length) return null;
    if (options.indexOf(target) === -1) {
      target = null;
      for (var i = 0; i < options.length; i += 1) {
        if (options[i].getAttribute('aria-current') === 'true') {
          target = options[i];
          break;
        }
      }
      target = target || options[0];
    }
    options.forEach(function (option) {
      option.setAttribute('tabindex', option === target ? '0' : '-1');
    });
    return target;
  }

  function moveOptionFocus(sheet, current, key) {
    var options = optionsFor(sheet);
    if (!options.length) return;
    var index = options.indexOf(current);
    if (key === 'Home') index = 0;
    else if (key === 'End') index = options.length - 1;
    else if (key === 'ArrowDown' || key === 'ArrowRight') index = (index + 1 + options.length) % options.length;
    else index = (index - 1 + options.length) % options.length;
    var next = setRovingOption(sheet, options[index]);
    if (next && typeof next.focus === 'function') next.focus();
  }

  function focusable(sheet) {
    if (!sheet || !sheet.querySelectorAll) return [];
    return Array.prototype.slice.call(sheet.querySelectorAll('button:not([disabled]):not([tabindex="-1"]), [href], [tabindex]:not([tabindex="-1"])'));
  }

  function markInert(element) {
    if (!element || element.nodeType !== 1) return;
    inertRecords.push({
      element: element,
      hadInert: element.hasAttribute('inert'),
      hadAria: element.hasAttribute('aria-hidden'),
      ariaValue: element.getAttribute('aria-hidden')
    });
    element.setAttribute('inert', '');
    element.setAttribute('aria-hidden', 'true');
  }

  function setBackgroundInert(sheet, active) {
    if (active) {
      var node = sheet;
      while (node && node.parentNode && node !== document.body) {
        Array.prototype.forEach.call(node.parentNode.children, function (sibling) {
          if (sibling !== node) markInert(sibling);
        });
        node = node.parentNode;
      }
      return;
    }
    inertRecords.forEach(function (record) {
      if (!record.hadInert) record.element.removeAttribute('inert');
      if (record.hadAria) record.element.setAttribute('aria-hidden', record.ariaValue);
      else record.element.removeAttribute('aria-hidden');
    });
    inertRecords = [];
  }

  function closeSheet(root, restoreFocus) {
    var sheet = sheetFor(root);
    var trigger = triggerFor(root);
    if (!sheet) return;
    sheet.hidden = true;
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    sheet.setAttribute('inert', '');
    document.documentElement.classList.remove('sale-sort-open');
    document.body.classList.remove('sale-sort-open');
    if (activeRoot === root) {
      setBackgroundInert(sheet, false);
      activeRoot = null;
    }
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (restoreFocus && trigger && typeof trigger.focus === 'function') trigger.focus();
  }

  function openSheet(root) {
    var sheet = sheetFor(root);
    var trigger = triggerFor(root);
    if (!sheet || !trigger) return;
    if (activeRoot === root && sheet.classList.contains('is-open')) return;
    if (activeRoot && activeRoot !== root) closeSheet(activeRoot, false);
    sheet.hidden = false;
    sheet.removeAttribute('inert');
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sale-sort-open');
    document.body.classList.add('sale-sort-open');
    setBackgroundInert(sheet, true);
    activeRoot = root;
    trigger.setAttribute('aria-expanded', 'true');
    var active = setRovingOption(sheet, sheet.querySelector(OPTION + '[aria-current="true"]') || sheet.querySelector(OPTION));
    if (active && typeof active.focus === 'function') {
      window.requestAnimationFrame(function () { active.focus(); });
    }
  }

  function navigate(value) {
    var url = new URL(window.location.href);
    if (value) url.searchParams.set('sort_by', value);
    else url.searchParams.delete('sort_by');
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  }

  function selectOption(root, option) {
    closeSheet(root, false);
    navigate(option.getAttribute('data-ch-native-sort-value'));
  }

  document.addEventListener('click', function (event) {
    var trigger = closest(event.target, TRIGGER);
    if (trigger) {
      var triggerRoot = rootFor(trigger);
      if (!triggerRoot) return;
      event.preventDefault();
      openSheet(triggerRoot);
      return;
    }

    var option = closest(event.target, OPTION);
    if (option) {
      var optionRoot = rootFor(option);
      if (!optionRoot) return;
      event.preventDefault();
      selectOption(optionRoot, option);
      return;
    }

    var close = closest(event.target, CLOSE);
    if (close) {
      var closeRoot = rootFor(close);
      if (!closeRoot) return;
      event.preventDefault();
      closeSheet(closeRoot, true);
    }
  });

  document.addEventListener('keydown', function (event) {
    var sheet = closest(event.target, SHEET);
    var root = rootFor(sheet);
    if (!sheet || !root || !sheet.classList.contains('is-open')) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeSheet(root, true);
      return;
    }

    var option = closest(event.target, OPTION);
    if (option) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight' ||
          event.key === 'ArrowUp' || event.key === 'ArrowLeft' ||
          event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        moveOptionFocus(sheet, option, event.key);
        return;
      }
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault();
        selectOption(root, option);
        return;
      }
    }

    if (event.key !== 'Tab') return;
    var controls = focusable(sheet);
    if (!controls.length) return;
    var first = controls[0];
    var last = controls[controls.length - 1];
    if (event.shiftKey && event.target === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && event.target === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
